import PropTypes from "prop-types";

// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

// Model
import PayPlansModel from "@PayPlans/models/Technicians";

function Technicians({ position = "", positionType = "", defaultSections = [] }) {
	return (
		<PayPlansFacade
			position={position}
			positionType={positionType}
			defaultSections={defaultSections}
			cacheManagement={{
				clearAbsoluteIndexes: [
					"payPlanCsiMetrics",
					"payPlansSidebarTree",
					"payPlanSalesPerformanceReportVersions",
					"technicianPayRates",
				],
			}}
		>
			<PayPlansModel />
		</PayPlansFacade>
	);
}
Technicians.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
	defaultSections: PropTypes.arrayOf(PropTypes.string),
};

export default Technicians;
